// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { select, Store } from '@ngrx/store';
import {
  selectIsLoading,
  selectOfflineTraffic,
  selectOfflineTrafficError,
} from '@coa/app/home/modules/dashboard/modules/dashboard-offline-traffic/store/offline-traffic.selectors';
import { Series } from '@coa/app/shared/stores-shared/models/series';
import { OfflineTrafficSeries } from '@coa/app/shared/stores-shared/models/offline-traffic-series';
import { ChartExtendedDataType } from '@coa/app/home/modules/floor-details/components/floor-details-body/floor-details-content/chart-extended-data.type';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { offlineTrafficRequested } from '@coa/app/home/modules/dashboard/modules/dashboard-offline-traffic/store/offline-traffic.actions';

@Component({
  selector: 'coa-dashboard-offline-traffic-content',
  templateUrl: './dashboard-offline-traffic-content.component.html',
  styleUrls: ['./dashboard-offline-traffic-content.component.scss'],
})
export class DashboardOfflineTrafficContentComponent implements OnInit, OnDestroy, OnChanges {
  @Input() categoryId: string;
  @Input() clientId: string;
  @Input() timePeriod: DateRangeFilter;
  @Input() paymentsEnabled: boolean;
  @Input() uniqueEnabled: boolean;

  isLoading$ = this.store.pipe(select(selectIsLoading));
  offlineTrafficError$ = this.store.pipe(select(selectOfflineTrafficError));

  noData: boolean;
  offlineTrafficSeries: Series[][];
  offlineTrafficLabels: string[];
  offlineTraffic: OfflineTrafficSeries;
  offlineTraffics: OfflineTrafficSeries[];

  chartExtendedData: ChartExtendedDataType;
  chartExtendedDataType = ChartExtendedDataType;

  tooltip = marker('Numbers show comparison of daily foot traffic relative to the highest point on the chart for the chosen time period, where a value of 100 equals the peak of foot traffic');
  private unsubscribe$ = new Subject<void>();

  constructor(
    private store: Store,
  ) {
  }

  ngOnChanges(): void {
    if (this.paymentsEnabled) {
      this.chartExtendedData = ChartExtendedDataType.PAYMENTS;
    } else if (this.uniqueEnabled) {
      this.chartExtendedData = ChartExtendedDataType.UNIQUE_VISITS;
    }
    if (this.clientId && this.timePeriod) {
      this.reloadData();
    }
  }

  showPayments(): void {
    this.chartExtendedData = ChartExtendedDataType.PAYMENTS;
  }

  showUniqueVisits(): void {
    this.chartExtendedData = ChartExtendedDataType.UNIQUE_VISITS;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit(): void {
    this.store.pipe(
      select(selectOfflineTraffic),
      takeUntil(this.unsubscribe$),
    ).subscribe((offlineTraffic) => {
      this.offlineTraffics = offlineTraffic;
      if (offlineTraffic && offlineTraffic.length > 0) {
        this.offlineTraffic = offlineTraffic.slice().shift();
        const series = [];
        const labels = [];

        offlineTraffic.forEach(entry => {
          series.push(entry.offlineTraffic);
          labels.push(entry.seriesName);
        });

        this.offlineTrafficSeries = series;
        this.offlineTrafficLabels = labels;
      }
      this.noData = (!offlineTraffic || offlineTraffic.length === 0);
      if (this.noData) {
        return;
      }
    });
  }

  private reloadData(): void {
    this.store.dispatch(offlineTrafficRequested({
      clientId: this.clientId,
      timePeriod: this.timePeriod,
      categoryId: this.categoryId,
    }));
  }
}
